/**
 * @generated SignedSource<<3a84d0f2a62525aa5d7e3dc5f1c13ac3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePerspectiveInputObject = {
  perspectiveId: string;
};
export type categorizePage_DeletePerspectiveMutation$variables = {
  input: DeletePerspectiveInputObject;
};
export type categorizePage_DeletePerspectiveMutation$data = {
  readonly deletePerspective: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly perspective: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type categorizePage_DeletePerspectiveMutation = {
  response: categorizePage_DeletePerspectiveMutation$data;
  variables: categorizePage_DeletePerspectiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Perspective",
  "kind": "LinkedField",
  "name": "perspective",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizePage_DeletePerspectiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePerspectiveMutationPayload",
        "kind": "LinkedField",
        "name": "deletePerspective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categorizePage_DeletePerspectiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePerspectiveMutationPayload",
        "kind": "LinkedField",
        "name": "deletePerspective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "95cb3625f9819ec72d440e3479718929",
    "id": null,
    "metadata": {},
    "name": "categorizePage_DeletePerspectiveMutation",
    "operationKind": "mutation",
    "text": "mutation categorizePage_DeletePerspectiveMutation(\n  $input: DeletePerspectiveInputObject!\n) {\n  deletePerspective(input: $input) {\n    perspective {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "25f5a4c0d7ce1b9f584820192eca52e2";

export default node;
